import React from 'react'

import ReferencedInput from 'src/components/inputs/Referenced/ReferencedInput'
import AgentAutocompleteInput from 'src/components/inputs/AgentAutocompleteInput'
import StringInput from 'src/components/inputs/StringInput'

/** @type {Partial<Record<import('@obvious.tech/constellation/Entity').TEntityName, import('src/types').TReference>>} */
const references = {
  Camera: {
    target: 'Camera',
    targetLabelKeyPath: 'name',
  },
  Alarm: {
    target: 'Alarm',
    targetLabelKeyPath: 'id',
  },
}

const EntityIdInput = ({
  formData,
  name,
  onChange,
  value,
  record,
  ...rest
}) => {
  const reference = references[formData.entityBehaviour]

  if (formData.entityBehaviour === 'Agent')
    return (
      <AgentAutocompleteInput
        name={name}
        onChange={onChange}
        record={record}
        value={value}
        {...rest}
      />
    )

  if (!reference)
    return (
      <StringInput
        name={name}
        {...rest}
        onChange={onChange}
        value={value}
        record={record}
      />
    )

  return (
    <span>
      <ReferencedInput
        name={name}
        {...rest}
        onChange={onChange}
        value={value}
        record={record}
        property={{
          reference,
        }}
      />
    </span>
  )
}

export default EntityIdInput
